import "./LoadingScreen.css";

import { useTranslation } from "react-i18next";

const LoadingScreen = ({ 
    isVisible = true,
    mainText = "ai-loading-message",
    description = "default-loading-message"
}) => {
    const { t } = useTranslation(["loading-screen"]);

    if (!isVisible) return null;

    return (
        <div className="loading-screen-overlay">
            <div className="loading-screen-content">
                <div className="spinner"></div>
                <h3 className="ai-loading-message">
                    {t(mainText)}
                </h3>
                <p className="default-loading-message">
                    {t(description)}
                </p>
            </div>
        </div>
    );
};

export default LoadingScreen;
